var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectPayroll',{on:{"get-selected-payroll":_vm.getSelectedPayroll}}),(_vm.clientReference)?_c('div',[_c('SelectClientInvoices',{attrs:{"clientReference":_vm.clientReference},on:{"get-selected-invoice":_vm.getSelectedInvoice}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }